/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Permission_ReadInputs */

const en_agent_authorization_permission_read = /** @type {(inputs: Agent_Authorization_Permission_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read this project's details and review status`)
};

const zh_agent_authorization_permission_read = /** @type {(inputs: Agent_Authorization_Permission_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`读取当前项目资料和审核状态`)
};

/**
* | output |
* | --- |
* | "Read this project's details and review status" |
*
* @param {Agent_Authorization_Permission_ReadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_permission_read = /** @type {((inputs?: Agent_Authorization_Permission_ReadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Permission_ReadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_permission_read(inputs)
	return zh_agent_authorization_permission_read(inputs)
});
export { agent_authorization_permission_read as "agent.authorization.permission.read" }